
import Vue from 'vue';
import { TransformedCmAccordion } from '~/transforms/transformModules';
import { generateFAQSchema } from '~/utility/jsonld/faq';

export default Vue.extend({
  props: {
    standalone: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object as () => TransformedCmAccordion['data'],
      required: true,
    },
  },
  head() {
    if (this.standalone === true) {
      // We don't want to add FAQ schema when the accordion is used as a module within a module
      return {
        script: [
          {
            type: 'application/ld+json',
            innerHTML: JSON.stringify(generateFAQSchema(this.data)),
          },
        ],
        __dangerouslyDisableSanitizers: ['script'],
      };
    }
    return {};
  },
  data() {
    return {
      headlineObject: {
        text: this.data.headline,
        fontStyle: this.data.headlineSize === 'default' ? 'h2' : 'h3',
      },
    };
  },
});
